'use client';

import { Text, TextProps } from '@/ui-components/atoms/Text/Text';
// import { useGSAP } from '@gsap/react';
// import { useRef } from 'react';
// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

interface Props extends TextProps {
    children: React.ReactNode;
}

// gsap.registerPlugin(ScrollTrigger);

export function AnimatedHeading(props: Props) {
    // const ref = useRef<HTMLDivElement>(null);

    // useGSAP(() => {
    //     if (!ref.current) return;

    //     const setTween = gsap.set(ref.current, { visibility: 'hidden' });

    //     const fromToTween = gsap.fromTo(
    //         ref.current.querySelectorAll('.char'),
    //         { display: 'inline-block', y: '100%' },
    //         {
    //             y: 0,
    //             duration: 0.6,
    //             delay: 0.2,
    //             ease: 'power3.out',
    //             onStart: () => {
    //                 gsap.set(ref.current, { visibility: 'unset' });
    //             },
    //             scrollTrigger: {
    //                 trigger: ref.current,
    //                 start: 'top 95%',
    //                 toggleActions: 'play none none none',
    //                 // markers: true, // Debugging markers
    //             },
    //         },
    //     );

    //     return () => {
    //         setTween.kill();
    //         fromToTween.kill();
    //     };
    // }, []);

    return <Text {...props} />;

    // return <Text {...props} ref={ref} style={{ visibility: 'hidden' }} />;
}
